import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/sections/Navbar";
import Footer from "./components/sections/Footer";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Services from "./components/pages/Services";
import Contact from "./components/pages/Contact";
import Blog from "./components/pages/Blog";
import Team from "./components/pages/Team";
import Testimonials from "./components/pages/Testimonials";
import WhatsAppButton from './components/sections/WhatsAppButton';
import BlogPost from "./components/pages/BlogPost";
import "./App.css";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
       <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/team" element={<Team />} />
        <Route path="/testimonials" element={<Testimonials />} />
      </Routes>
      <WhatsAppButton /> {/* floating WhatsApp button */}
      <Footer />
      </>
  );
}

export default App;
